export class Social {
    public handle: string;
    public about: string;
}